let turnstileToken = null;

export const setTurnstileTokenValue = (token) => {
  turnstileToken = token || null;
};

export const getTurnstileTokenValue = () => turnstileToken;

export const clearTurnstileTokenValue = () => {
  turnstileToken = null;
};


export const isTurnstileBootstrapPresent = () => {
  if (typeof window === "undefined") return false;
  if (window.__TURNSTILE_ENABLED === true) return true;
  if (
    typeof window.__TURNSTILE_SITE_KEY === "string" &&
    window.__TURNSTILE_SITE_KEY.length > 0
  ) {
    return true;
  }
  if (typeof window.__startTurnstileEarly === "function") return true;
  if (Array.isArray(window.__turnstileTokenWaiters)) return true;
  return false;
};
